import { useCurrentDay } from '../current_time/hooks/useCurrentDay';

export default useCurrentDay;
